// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'csp',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  serverUrl: 'http://localhost:8080',
  keycloak: {
    // Url of the Identity Provider
    issuer: 'https://pims-idp.cspinnova.it',
    // Realm
    realm: 'PiMS',
    clientId: 'pims-fe-local-dev',
  },
  restURL: {
    login: "https://pims-fe.cspinnova.it/auth/iam",
    core: "https://pims-fe.cspinnova.it/api/core/",
    rates: "https://pims-fe.cspinnova.it/api/rates/",
    booking: "https://pims-fe.cspinnova.it/api/booking/"
  }

};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
